module.exports = __webpack_public_path__ + "media/cluck.06c6726b.wav";